import Api from '../api'

export default ({

  state: {
    balanceBroughtDownSettlementLists: [],
    balanceCarryOverLists: [],
    balanceSettlementLists: []
  },
  mutations: {
    SET_BROUGHTDOWN_LIST (state, balanceBroughtDownSettlementList) {
      state.balanceBroughtDownSettlementLists = balanceBroughtDownSettlementList
    },
    ADD_BROUGHT_DOWN(state, accountMaster) {
      let balanceBroughtDownSettlementList = state.balanceBroughtDownSettlementLists.concat(accountMaster)
      state.balanceBroughtDownSettlementLists = balanceBroughtDownSettlementList
    },
    SET_BALANCE_CARRYOVER_LIST (state, balanceCarryOverList) {
      state.balanceCarryOverLists = balanceCarryOverList
    },
    SET_BALANCE_SETTLEMENT_LIST (state, balanceSettlementList) {
      state.balanceSettlementLists = balanceSettlementList
    }
  },
  actions: {
    async loadBalanceBroughtDownList({commit}) {
      let response = await Api.request('get', '/accountBroughtDown/broughtDownAccountList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_BROUGHTDOWN_LIST', response.data.data)
      return response
    },
    async saveBalanceBroughtDown({commit}) {
      let response = await Api.request('put', '/accountBroughtDown/saveBalanceBroughtDown/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '')
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BROUGHT_DOWN', savedAccountMaster)
      }
      return response
    },
    async updateItemBalanceBroughtDown({commit}, warehouseId) {
      let response = await Api.request('put', '/accountBroughtDown/updateItemBalanceBroughtDown/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '/' + warehouseId)
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BROUGHT_DOWN', savedAccountMaster)
      }
      return response
    },
    async saveSettelAccount({commit}) {
      let response = await Api.request('put', '/accountBroughtDown/saveAccountSettlement/' + this.state.organisationid + '/' + this.state.user.id + '/' + this.state.fyId + '')
      let savedAccountMaster = response.data.data
      if (response.data.status === 'SUCCESS') {
        commit('ADD_BROUGHT_DOWN', savedAccountMaster)
      }
      return response
    },
    async loadBalanceCarryOverList({commit}) {
      let response = await Api.request('get', '/accountBroughtDown/balanceCarryOverList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_BALANCE_CARRYOVER_LIST', response.data.data)
      return response
    },
    async loadBalanceSettledList({commit}) {
      let response = await Api.request('get', '/accountBroughtDown/fiscalYearSettledList/' + this.state.organisationid + '/' + this.state.fyId + '')
      commit('SET_BALANCE_SETTLEMENT_LIST', response.data.data)
      return response
    }
  },
  getters: {
  }
})



// WEBPACK FOOTER //
// ./src/store/finalYearSettlement.js